import React, { useState ,useEffect} from "react";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import MenuIcon from "@mui/icons-material/MenuOutlined";
import Search from "@mui/icons-material/SearchOutlined";
import Paper from "@mui/material/Paper";
import Badge from "@mui/material/Badge";
import Notifications from "@mui/icons-material/Notifications";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { USER_SO_KEY } from "../utils/accountUtils";
import { getSessionStorage } from "../utils/StorageUtil";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SendIcon from "@mui/icons-material/Send";

import ProfileContext from "../pages/private/profile/ProfileContext";

import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";
import { cleanSOData } from "../utils/accountUtils";
import { getNotificationsByUser ,patchNotificationsByUser} from '../api/NotificationsApi'

import  { FULL_MENU } from '../api/config/Constants'

const menu = {
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "0px 0px 5px 5px",
  "& .MuiPaper-root": {
    backgroundColor: "#103115",
    color: "#ffffff",
  },
};

type Props = {
  title?: string;
  selectedOptionIndex?: number;
  goBack?: boolean;
  search?: boolean;
  send?: any;
  refresh?:boolean;
};

export default function ProfileBottomNav(props: Props) {
  const [value, setValue] = React.useState(0);
  const [refreshNotification, setRefreshNotification] = useState(false);
  const [countNot, setCountNot] = useState(null);
  const [userId, setUserId] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();
  const allowedRoles = ["DIRECTORIO", "ADMINISTRATIVO", "RESPONSABLE_FLOTA"];

  const user = getSessionStorage(USER_SO_KEY);

  useEffect(() => {
    (async () => {
      await getNotificationsByUser('','1')
        .then((response) => {
          console.log('response ',response)
          setCountNot(response?.data?.length)
          if(response?.data && response?.data[0]?.userId){
            setUserId(response?.data[0]?.userId);
          }

        })
        .catch((e) => {
          console.log('Error', e)
        })

    })()

  }, [props])

  const handleLogOut = () => {
    cleanSOData();
    navigate("/web/login" );
  };

  const handleChangePassword = () => {
    navigate("/web/change-password" );
  };

  const handleProfile = () => {
    navigate("/web/profile" );
  };

  const handleCatalog = () => {
    navigate("/web/catalog" );
  };

  const handleSearchCatalog = () => {
    navigate("/web/search-vehicles" );
  };

  const handleIndicators = () => {
    navigate("/web/" );
  };

  const handleLogin = () => {
    navigate("/web/login" );
  };

  const handleList = () => {
    navigate("/web/vehicleFleet" );
  };

  const handleTickets = () => {
    navigate("/web/tickets" );
  };
  const handleBack = () => {
    //navigate("/web/" );
    navigate(-1);
    
  };

  const handleFaqs = () => {
    navigate("/web/faqs" );
  };

  const handleContact = () => {
    navigate("/web/contact" );
  };

  const handleChecklist = () => {
    navigate("/web/checklist");
  };

  const handleBackOffice = () => {
    window.location.href = '/';
  };

  const handleWorkOrderDesktop = () => {
    window.location.href = '/web/workOrderDesktop';
  };

  const handleInvoicesDesktop = () => {
    window.location.href = '/web/InvoiceDesktop';
  };

  
  const handleNotifications = async() => {
    if(userId){
      const body={
                    userId: userId,
                    isNotif: false
                  }
      await patchNotificationsByUser(userId,body)
    }

    navigate("/web/notifications");
  };

  const settings = [
    {
      name: "Mi perfil",
      action: handleProfile,
    },
    {
      name: "Cambiar contraseña",
      action: handleChangePassword,
    },
    { name: "Cerrar sesión", action: handleLogOut },
  ];
  console.log(user);
  
  const menuSettings = () => {
    let menuData=[];
    if (user?.role == "RESPONSABLE_FLOTA") {
      menuData=
        [
          {
            name: "Inicio",
            action: handleIndicators,
          },
          {
            name: "Catálogo OLCA",
            action: handleCatalog,
          },
          { name: "Buscar Vehículo", action: handleSearchCatalog },
          { name: "Listar Vehículos", action: handleList },
          { name: "Tickets", action: handleTickets },
          { name: "Contactar al Directorio", action: handleContact },
          { name: "Checklist", action: handleChecklist },
        ];
      }else if (user?.role == "LIDER_BASE") {
        menuData=      [
          {
            name: "Inicio",
            action: handleIndicators,
          },
          {
            name: "Catálogo OLCA",
            action: handleCatalog,
          },
          { name: "Buscar Vehículo", action: handleSearchCatalog },
          { name: "Listar Vehículos", action: handleList },
          { name: "Tickets", action: handleTickets },
          { name: "Checklist", action: handleChecklist },
          { name: "BackOffice", action: handleBackOffice },
        ];
    } else {
      menuData=      [
        {
          name: "Inicio",
          action: handleIndicators,
        },
        {
          name: "Catálogo OLCA",
          action: handleCatalog,
        },
        { name: "Buscar Vehículo", action: handleSearchCatalog },
        { name: "Listar Vehículos", action: handleList },
        { name: "Tickets", action: handleTickets },
        { name: "Checklist", action: handleChecklist },
        ["OPERATIVO","ADMINISTRATIVO","DIRECTORIO","DOCUMENTO"].includes (user?.role) ?  { name: "BackOffice", action: handleBackOffice }:null
      ];
    }
  if (allowedRoles.includes(user?.role)) {
      menuData.push({
        name: "Órdenes de Trabajo",
        action: handleWorkOrderDesktop,
      });
  }
  if (user?.role === "RESPONSABLE_FLOTA") {
    menuData.push({
      name: "Facturas",
      action: handleInvoicesDesktop, // función que abre la pantalla de facturas
    });
  }
   if(FULL_MENU=='false'){
    const elementosAEliminar = ["Catálogo OLCA"];

    const updatedMenuData = menuData.filter(
      (item:any) => !elementosAEliminar.includes(item.name)
    );
      return updatedMenuData;

   }


    return menuData;
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };

  return (
    <ProfileContext.Consumer>
      {(context) => {
        const safeNavigate = (callback: any) => {
          if (props.selectedOptionIndex === 0 && context.editing) {
            context.setDialogOpen(true);
            context.onCloseDialog = callback;
          } else {
            callback();
          }
        };
        return (
          <Box>
            <Box sx={{ paddingBottom: "56px" }}></Box>
            <Paper
              sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}
              elevation={3}
            >
              <BottomNavigation
                value={value}
                sx={{ background: "#103115", height: 89 }}
                onChange={(event, newValue) => {
                  setValue(newValue);
                }}
              >
                {getSessionStorage(USER_SO_KEY) && (
                    <BottomNavigationAction
                      className="footerPrimary"
                      onClick={handleOpenMenu}
                      icon={<MenuIcon />}
                    />
                )}
              {getSessionStorage(USER_SO_KEY) && (
                    <BottomNavigationAction
                      className="footerPrimary"
                      onClick={handleNotifications}
                      icon={
                        <Badge
                          badgeContent={countNot}
                          color="warning"
                          className="footerPrimary"
                          max={99}
                        >
                          <Notifications />
                        </Badge>
                      }
                    />
                )}
                <BottomNavigationAction
                  className="footerPrimary"
                  sx={{ mr: 2 }}
                  onClick={handleFaqs}
                  icon={<HelpOutlineIcon />}
                />

                <Box sx={{ flexGrow: "1" }} />
                {props.search && (
                  <BottomNavigationAction
                    className="footerPrimary"
                    sx={{ mr: 2 }}
                    onClick={handleSearchCatalog}
                    icon={
                      <Fab className="bottom-nav-fab">
                        <Search />
                      </Fab>
                    }
                  />
                )}
                {props.goBack && (
                  <BottomNavigationAction
                    className="footerPrimary"
                    sx={{ mr: 2 }}
                    onClick={handleBack}
                    icon={
                      <Fab className="bottom-nav-fab">
                        <ArrowBackIcon />
                      </Fab>
                    }
                  />
                )}

                {props.send && (
                  <BottomNavigationAction
                    className="footerPrimary"
                    sx={{ mr: 2 }}
                    onClick={props.send}
                    icon={
                      <Fab sx={{ width: 100 }} className="bottom-nav-fab">
                        Enviar&nbsp;
                        <SendIcon />
                      </Fab>
                    }
                  />
                )}
              </BottomNavigation>
            </Paper>

            {!!props.title && (
              <Box>
                <p className="formTitle" style={{ margin: "57px 0 0" }}>
                  {props.title}
                </p>
                <Divider
                  sx={{
                    margin: "17px 6% 20px",
                    display: "block",
                    background: "#008F39",
                  }}
                  variant="middle"
                />
              </Box>
            )}
            <Menu
              sx={menu}
              id="menu-user"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting, index) => (
                <Box key={index}>
                  <MenuItem
                    disabled={props.selectedOptionIndex === index}
                    onClick={() => safeNavigate(setting.action)}
                  >
                    <Box sx={{ flexGrow: 1 }}></Box>
                    <Typography>{setting.name}</Typography>
                  </MenuItem>
                  {settings[index + 1] && <Divider />}
                </Box>
              ))}
            </Menu>
            <Menu
              sx={menu}
              id="menu-appbar"
              anchorEl={anchorElMenu}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElMenu)}
              onClose={handleCloseMenu}
            >
              {menuSettings().map((setting, index) => (
                <Box key={index}>
                  <MenuItem onClick={() => safeNavigate(setting?.action)}>
                    <Box sx={{ flexGrow: 1 }}></Box>
                    <Typography>{setting?.name}</Typography>
                  </MenuItem>
                  {menuSettings()[index + 1] && <Divider />}
                </Box>
              ))}
            </Menu>
          </Box>
        );
      }}
    </ProfileContext.Consumer>
  );
}
